var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#FAFBFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1732 7.5L20.0056 8.06967V24.6002L20.1732 24.7675L27.8465 20.2319L20.1732 7.5Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1732 7.5L12.5 20.2319L20.1732 24.7676V16.7441V7.5Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1732 26.2204L20.0787 26.3355V32.2241L20.1732 32.5L27.8511 21.687L20.1732 26.2204Z",
    fill: "#3C3C3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1732 32.5V26.2205L12.5 21.687L20.1732 32.5Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1732 24.7674L27.8463 20.2318L20.1732 16.7441V24.7674Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.2318L20.1732 24.7674V16.7441L12.5 20.2318Z",
    fill: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.eb87402c5ed7f6ce973f0486c26cfebd.svg";
export { ForwardRef as ReactComponent };